

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Referral } from '@/api/model/referral'
import { availableReferralStatuses, ReferralStatus } from '@/api/types'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { PipelinePhaseAPI, StatusReasonAPI } from '@/api/backend-client'
import { StatusReason } from '@/api/model/status-reason'

@Component
export default class ReferralFollowupForm extends Vue {
    @Prop() readonly value!: Referral
    phases: PipelinePhase[] = []
    statusReasons: StatusReason[] = []
    statusValue: any[] = []

    loading = true

    async mounted() {
        this.loading = true
        this.value.status = ReferralStatus.OPEN
        this.value.newStatusReason = null
        this.statusValue = [this.value.status, this.value?.newStatusReason?.id]
        this.phases = (await PipelinePhaseAPI.getAll({ pipeline: this.value.pipeline.resourceIdentifier }))
            .sort((a, b) => a.compareTo(b))
            .filter(phase => phase.active)
        this.value.phase = this.value.phase || this.phases[0]
        this.statusReasons = (await StatusReasonAPI.getAll({ company: this.$currentCompany.resourceIdentifier }))
            .sort((a, b) => a.name.localeCompare(b.name))
            .filter(statusReason => statusReason.active)
        this.loading = false
    }

    setPhase(phaseId) {
        this.value.phase = this.phases.find(phase => phase.id === phaseId)
    }

    @Watch('statusValue')
    setStatus() {
        const currentStatusReason = this.statusReasons.find(statusReason => statusReason.id === this.statusValue[1])

        this.value.status = this.statusValue[0]
        this.value.newStatusReason = currentStatusReason ? currentStatusReason : null
    }

    get assignableUsers(): User[] {
        if (this.$currentCompany === null) {
            return []
        }

        return this.$currentCompany.getAvailableUsers()
    }

    get statusOptions() {
        return availableReferralStatuses(this.$currentCompany).map((status: ReferralStatus) => {
            return {
                label: this.$t('referral.status.' + status),
                value: status,
                options: this.statusReasons.filter(statusReason => statusReason.status === status).map(statusReason => {
                    return {
                        label: statusReason.name,
                        value: statusReason.id,
                        options: [],
                    }
                }),
            }
        })
    }

    get phaseOptions() {
        return this.phases.map(phase => {
            return {
                label: phase.name,
                value: phase.id,
                options: [],
            }
        })
    }
}
